import TweenMax from 'TweenMax';


class Animation {
    constructor() {}

    slideIn(el){
        return TweenMax.to(el,1,{left:0, top:0},.5)
    }


    headerIntro(header){
        let logo = header.querySelector('.logo');
        let img = header.querySelector('.background-img');
        // let logoRow = header.querySelector('.logo__row');

        var tl = new TimelineLite({delay:2});
        tl.to(header, 1, {height: "80px"})
        tl.to(img, 1, {opacity: '0'})
        tl.to(logo, 1, {margin: "6px 0 ",height: "64.34px", width: "136.8px"},0)
        tl.call(()=>{
          document.querySelector('body').classList.remove('noScroll')
        },[], this, .5)
        // tl.to(logoRow, 1, {justifyContent:"flex-start"}, 0)
          // .fromTo(logo, 1, {fontSize: "6em"},{fontSize: "3em"}, 0)

          return tl;
    }
}

export default Animation;



// WEBPACK FOOTER //
// ./themes/art-library/javascript/Animations.js